module.exports = __webpack_public_path__ + "fcc6ab6400b2a4d195e204fe1d30a131.pdf";